export default __webpack_public_path__ + "static/14-92118ca5728fe88a3b8baa79b5e15d4a.png";